import styled from 'styled-components';
import { ColorSelectStyled } from '../ColorSelectStyled';
import { rem } from 'polished';

export const ColorSelectStyledDS = styled(ColorSelectStyled)`
    .name {
        font-size: ${({ theme }) => theme.fontSizes.h5};
    }

    .react-multiple-carousel__arrow {
        &--right,
        &--left {
            border-radius: ${rem(8)};
        }
    }
`;
